import cn from 'classnames'
import type { OverlayScrollbarsComponent } from 'overlayscrollbars-react'
import React, { useRef } from 'react'
import { useContextSelector } from 'use-context-selector'

import { LayoutScroll } from 'components/LayoutPage'
import Badge from 'components/uiKit/Badge'
import { EmployeePreferencesTab } from 'gql/__generated__/graphql'
import { useTemplatesAllTotal } from 'gql/templates/apollo'
import { testProps } from 'utils/test/qaData'

import { TABS } from '../helper'
import { TemplatePickerContext } from '../hooks'
import * as s from './Tags.module.scss'

interface ITagsProps {
  setTab: (value: EmployeePreferencesTab) => void
}
const Tags: React.FC<ITagsProps> = ({ setTab }) => {
  const {
    collection,
    tag,
    setTag,
    tab: tabProps,
    companyId,
    sectionId = '',
    setCollection,
    blockMode,
    tagOptions,
    showTags,
  } = useContextSelector(TemplatePickerContext, (value) => value)
  const scrollRef = useRef<OverlayScrollbarsComponent>(null)
  const { data } = useTemplatesAllTotal({ search: { companyId, sectionId, mode: blockMode } })

  const onChangeTab = (e: React.MouseEvent<HTMLDivElement>) => {
    const value = e.currentTarget.dataset.value
    const tab = TABS.find((item) => item.value === value)
    if (tab) {
      setCollection(null)
      setTab(tab.value)
    }
  }

  const onChangeTag = (value: string | null) => {
    const tagId = tagOptions.find((tag) => tag.value === value)?.value || null
    setTag(tagId)
  }

  const badge: { [key in EmployeePreferencesTab]?: number } = {
    [EmployeePreferencesTab.favorites]: data?.data.favorites || 0,
  }

  const showTabs = !collection

  return (
    <div className={s.root}>
      <LayoutScroll ref={scrollRef} sizeAutoCapable>
        {showTabs && (
          <div className={s.tabs}>
            {TABS.map(({ value, label }) => {
              const count = badge[value]
              return (
                <div
                  className={cn(s.menuItem, { [s.active]: tabProps === value })}
                  data-value={value}
                  key={value}
                  onClick={onChangeTab}
                  {...testProps({ el: 'menuItem', value, name: 'templatesTabs' })}
                >
                  {count !== undefined ? (
                    <Badge count={count} offset={[8, 20]} placement='right'>
                      <div className={s.tag} key={value}>
                        {label}
                      </div>
                    </Badge>
                  ) : (
                    <div className={s.tag} key={value}>
                      {label}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        )}
        <div>
          {showTags && (
            <>
              {tagOptions.map(({ value, label }) => (
                <div
                  className={cn(s.menuItem, { [s.active]: tag === value })}
                  key={value}
                  onClick={() => onChangeTag(value)}
                  {...testProps({ el: 'menuItem', value, name: 'templatesTags' })}
                >
                  <div className={s.tag} key={value}>
                    {label}
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </LayoutScroll>
    </div>
  )
}

export default React.memo(Tags)
